import {useLocation, useNavigate, useParams} from "react-router-dom";
import {Helmet} from "react-helmet-async";
import {
    Box,
    Card,
    CardContent,
    CircularProgress,
    Container,
    Stack,
    Tab,
    Table, TableBody, TableCell,
    TableHead, TableRow,
    Typography
} from "@mui/material";
import { GeneralLayout } from "../layouts/GeneralLayout";
import { useState, useEffect } from "react";
import {TabContext, TabList} from "@mui/lab";
import StatementCard from "../components/session/StatementCard";
import FacultyStatementCard from "../components/session/FacultyStatementCard";
import {useGetSessionStatementsQuery} from "../store/session/sessionApi";
import PageTitle from "../components/PageTitle";

export default function ManageStatementsPage() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [tabValue, setTabValue] = useState(localStorage.getItem('sessionStatementsSavedTab') ?? '0');
    const { data } = useGetSessionStatementsQuery({ sessionId: id, toFillGaps: true });
    const params = useParams();
    const location = useLocation();

    useEffect(() => {
        // Attempt to get tab from URL parameter or query
        const tabFromURL = params.tab || new URLSearchParams(location.search).get('tab');
        if (tabFromURL) {
            setTabValue(tabFromURL);
        }
    }, [params, location]);

    function onTabChange(value) {
        setTabValue(value);
        localStorage.setItem('sessionStatementsSavedTab', value);
    }
    
    function getStatementCard(statement, d, facultyName, previousStatement) {
        if (previousStatement) {
            console.log('getStatementCard -----------');
            console.log('disc', d);
            console.log('statement', statement);
            console.log('previousStatement', previousStatement);
            console.log('');
        }
        
        return <FacultyStatementCard statementId={statement?.statementId ?? 0}
            statementNumber={statement?.statementNumber}
            orderNumber={statement?.orderNumber}
            canCreate={statement && statement.canCreate || previousStatement && previousStatement.dateOfClose}
            closingDate={statement?.dateOfClose}
            sessionDisciplineDetailId={statement?.sessionDisciplineDetailId}
            eventDateTime={statement?.eventDateTime}
            passingType={statement?.passingType}
            controlType={d?.controlType}
            facultyName={facultyName}
            previousClosed={statement?.previousClosed}
            hasDebtors={statement?.hasDebtors}
        />
    }

    function controlTypeToInternalType(controlType) {
        if (controlType === 0)
            return 0;

        if (controlType === 1 || controlType === 2)
            return 1;

        return 2;
    }
    
    return  <GeneralLayout>
        <PageTitle title={`Управление ведомостями`} />

        <Container>
            <Stack
                padding="120px 0px 0px 100px"
                direction="column"
                spacing={2}
            >
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        {data === null || data === undefined
                            ? <CircularProgress/>
                            : <></>} Управление ведомостями {data?.courseName}
                    </Typography>
                </Stack>

                <Card>
                    <TabContext value={tabValue}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={(event, value) => { onTabChange(value); }}>
                                <Tab label="Экзамены" value="0" />
                                <Tab label="Зачёты" value="1" />
                                <Tab label="Курсовые работы" value="2" />
                            </TabList>
                        </Box>
                    </TabContext>
                    
                    <CardContent>
                        {data?.disciplines?.filter((d) => controlTypeToInternalType(d.controlType) === parseInt(tabValue, 10))
                            .map((d) => {
                            return <>
                                <Typography variant="h5">{d.disciplineName}</Typography>
                                <Typography fontSize="small">Кафедра {d.chairName}</Typography>
                                <br />
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Группа</TableCell>
                                            <TableCell align="center">Осн. ведомость</TableCell>
                                            <TableCell align="center">Доп. ведомость</TableCell>
                                            <TableCell align="center">Комиссионная</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {d.groups.filter((g) => g.passingType === 0).map((g) => {
                                            return <TableRow>
                                                <TableCell>{g.groupName}</TableCell>
                                                <TableCell align="center">
                                                    { getStatementCard(d.groups.find((s) => s.passingType === 0 && s.groupName === g.groupName), d, data.facultyName) }
                                                </TableCell>
                                                <TableCell align="center">
                                                    {getStatementCard(d.groups.find((s) => s.passingType === 1 && s.groupName === g.groupName), d, data.facultyName) }
                                                </TableCell>
                                                <TableCell align="center">
                                                    {getStatementCard(d.groups.find((s) => s.passingType === 2 && s.groupName === g.groupName), d, data.facultyName) }
                                                </TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>
                                
                                <br />
                            </>
                        })}
                    </CardContent>
                </Card>
                
                <br />
            </Stack>
        </Container>
    </GeneralLayout>
}